import React, { useState } from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Faqs = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(index === activeIndex ? null : index);
    };

    const questions = [
        {
            id: 1,
            question: "What services does your company offer in the oil and gas sector?",
            answer:
                "Our company specializes in a range of maintenance services for the oil and gas industry, including equipment servicing, pipeline inspections, corrosion control, and facility upkeep.",
        },
        {
            id: 2,
            question: "How do you ensure safety standards are met in your maintenance operations?",
            answer:
                "Safety is our top priority. We strictly adhere to industry regulations and implement comprehensive safety protocols. Our team undergoes regular training to stay updated on safety practices and procedures.",
        },
        {
            id: 3,
            question: "What sets your maintenance services apart from competitors?",
            answer:
                "We pride ourselves on our expertise, reliability, and commitment to customer satisfaction. Our proactive approach to maintenance minimizes downtime and optimizes equipment performance, providing cost-effective solutions tailored to our clients' needs.",
        },
        {
            id: 4,
            question: "How do you handle emergency maintenance situations?",
            answer:
                "We have a dedicated emergency response team available 24/7 to address any urgent maintenance needs. Our rapid response capabilities ensure minimal disruption to operations and swift resolution of critical issues.",
        },
        {
            id: 5,
            question: "What measures do you take to minimize environmental impact during maintenance activities?",
            answer:
                "Environmental stewardship is integral to our operations. We employ eco-friendly practices, such as utilizing biodegradable chemicals, implementing spill prevention measures, and adhering to strict waste management protocols.",
        },
        {
            id: 6,
            question: "How do you stay updated on industry trends and technological advancements?",
            answer:
                "We maintain close partnerships with industry organizations, participate in conferences, and invest in ongoing training and research. This allows us to stay ahead of emerging trends and incorporate cutting-edge technologies into our maintenance strategies.",
        },
        {
            id: 7,
            question: "Can you outline your quality assurance and control processes?",
            answer:
                "We have rigorous quality assurance procedures in place at every stage of the maintenance process. From initial inspection to final testing, we conduct thorough checks to ensure adherence to specifications and standards, delivering high-quality results consistently.",
        },
        {
            id: 8,
            question: "How do you manage project timelines and budgets effectively?",
            answer:
                "We employ robust project management techniques, utilizing advanced software tools to plan, monitor, and optimize project schedules and budgets. Our experienced team is skilled at identifying potential risks and implementing strategies to mitigate them, ensuring projects are completed on time and within budget.",
        },
        {
            id: 9,
            question: "What is your approach to fostering long-term partnerships with clients?",
            answer:
                "We prioritize open communication, transparency, and reliability in our client relationships. By understanding our clients' unique needs and challenges, we strive to deliver tailored solutions that add value and build trust over time.",
        },
        {
            id: 10,
            question: "Can you provide examples of previous successful maintenance projects?",
            answer:
                "Certainly. We've successfully completed projects ranging from routine equipment servicing to complex repairs and upgrades. Our track record includes extending the lifespan of aging infrastructure, enhancing operational efficiency, and mitigating potential risks.",
        },
    ];

    return (
        <div>
            {/* <Navbar /> */}
            <div className="container mx-auto max-w-screen-lg px-6 py-10 mt-20">
                <h1 className="text-4xl font-extrabold text-center mb-10 text-purple-700">
                    Frequently Asked Questions
                </h1>
                <div className="space-y-6">
                    {questions.map((item, index) => (
                        <div
                            key={item.id}
                            className={`border rounded-lg shadow-lg overflow-hidden transition-transform transform ${
                                activeIndex === index ? "scale-105" : "scale-100"
                            }`}
                        >
                            <div
                                onClick={() => toggleAccordion(index)}
                                className="bg-purple-100 hover:bg-purple-200 px-6 py-4 cursor-pointer flex justify-between items-center"
                            >
                                <div className="flex items-center">
                                    <h2 className="text-lg font-bold text-purple-600">{`0${item.id}`}</h2>
                                    <h3 className="ml-4 text-purple-800 font-medium">{item.question}</h3>
                                </div>
                                <span className="text-purple-600 text-2xl">
                                    {activeIndex === index ? "-" : "+"}
                                </span>
                            </div>
                            {activeIndex === index && (
                                <div className="bg-white px-6 py-4">
                                    <p className="text-gray-700 leading-relaxed">{item.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
            {/* <Footer /> */}
        </div>
    );
};

export default Faqs;
